<template lang="pug">
v-form(ref="form" @submit.prevent="onSubmit")
  .text-h5.my-4.text-center.font-weight-bold {{title}}
  v-alert(v-if="errors.length" dense outlined type="error")
    div(v-for="error in errors") {{error}}
  v-row(dense)
    v-col(cols="12" sm="6")
      v-text-field(v-model="form.first_name" :rules="v.first_name" label="Nombre" outlined)
    v-col(cols="12" sm="6")
      v-text-field(v-model="form.last_name" :rules="v.last_name" label="Apellido" outlined)
    v-col(cols="12")
      v-text-field(v-model="form.email" :rules="v.email" label="Correo" outlined :disabled="defaultValues.email !== undefined")
    v-col(cols="12" sm="6")
      v-text-field(v-model="form.business_name" :rules="v.business_name" label="Nombre de la empresa" outlined)
    v-col(cols="12" sm="6")
      v-select(v-model="form.line_of_business" :rules="v.line_of_business" label="Rubro de la empresa" outlined :items="lineOfBusinessChoices")
    v-col(cols="12")
      v-text-field(v-model="form.position" :rules="v.position" label="Tu cargo dentro de la empresa" outlined)
    v-col(cols="12")
      .text-subtitle-2.font-weight-medium.mb-1 ¿Cómo vas a modelar lo que vendes?
      .caption.grey--text.mb-2 Podrás cambiarlo después en Configuración.
      v-row(dense)
        v-col(cols="12" sm="6")
          v-card.mode-card(outlined :class="{'mode-card--active': form.catalog_mode === 'simplificado'}" @click="form.catalog_mode = 'simplificado'")
            v-card-text
              .d-flex.align-center.mb-1
                v-icon.mr-2(:color="form.catalog_mode === 'simplificado' ? 'primary' : 'grey'") mdi-view-list-outline
                span.font-weight-medium Simplificado
                v-chip.ml-2(x-small color="primary" outlined) Recomendado
                v-spacer
                v-icon(v-if="form.catalog_mode === 'simplificado'" color="primary") mdi-check-circle
              .caption.grey--text.text--darken-1 Líneas de negocio con productos o servicios concretos, cada uno con su ticket promedio. Ideal para servicios.
        v-col(cols="12" sm="6")
          v-card.mode-card(outlined :class="{'mode-card--active': form.catalog_mode === 'detallado'}" @click="form.catalog_mode = 'detallado'")
            v-card-text
              .d-flex.align-center.mb-1
                v-icon.mr-2(:color="form.catalog_mode === 'detallado' ? 'primary' : 'grey'") mdi-file-tree
                span.font-weight-medium Detallado
                v-spacer
                v-icon(v-if="form.catalog_mode === 'detallado'" color="primary") mdi-check-circle
              .caption.grey--text.text--darken-1 Familias con variantes y atributos (color, gramaje, volumen) que generan SKU distintos. Para catálogos de productos.
    v-col(cols="12" sm="6")
      v-text-field(v-model="form.password1" :rules="v.password1" label="Contraseña" outlined type="password")
    v-col(cols="12" sm="6")
      v-text-field(v-model="form.password2" :rules="v.password2" label="Repetir Contraseña" outlined type="password")
  v-btn(type="submit" block color="primary" large :loading="loading") {{submitText}}
</template>

<script>
import { mapActions } from 'vuex'
import validations from '../../shared/formValidations'
import FromMixn from '../mixins/FormMixin.vue'

export default {
  mixins: [FromMixn],
  props: {
    defaultValues: {
      type: Object,
      default: () => ({})
    },
    noRedirect: {
      type: Boolean,
      default: false
    },
    submitText: {
      type: String,
      default: 'Registrarme'
    },
    title: {
      type: String,
      default: 'Empecemos!'
    }
  },
  data () {
    return {
      form: {
        first_name: null,
        last_name: null,
        email: null,
        password1: null,
        password2: null,
        business_name: null,
        line_of_business: null,
        position: null,
        catalog_mode: 'simplificado',
      },
      lineOfBusinessChoices: [],
      errors: [],
      loading: false,

    }
  },
  methods: {
    ...mapActions('auth', ['signup']),
    ...mapActions('business', ['getLineOfBusinessChoices']),
    onError () {
      this.errors = ['El correo ya está registrado']
    },
    onSuccess (response) {
      this.$emit('success', response)
      if (!this.noRedirect) {
        this.$router.push('/')
      }
    },
    getAction () {
      return this.signup
    }
  },
  computed: {
    v () {
      return {
        first_name: [validations.isRequired],
        last_name: [validations.isRequired],
        email: [validations.isRequired, validations.isEmail],
        password1: [validations.isRequired, validations.minLength(8), validations.password],
        password2: [validations.isRequired, validations.equals(this.form.password1, 'La contraseña no coincide')],
        business_name: [validations.isRequired],
        line_of_business: [validations.isRequired],
        position: [validations.isRequired],
      }
    }
  },
  created () {
    this.form.email = this.defaultValues.email
    this.getLineOfBusinessChoices().then(({ data }) => {
      if (data) {
        this.lineOfBusinessChoices = data
      }
    })
  }
}
</script>

<style scoped>
.mode-card {
  cursor: pointer;
  height: 100%;
  transition: border-color .15s;
}
.mode-card--active {
  border-color: var(--v-primary-base) !important;
  border-width: 2px;
}
</style>
